import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"
import { showModal } from "../../features/modal/modalSlice"
import PageTopTitle from "../shared/PageTopTitle"
import Button from "../shared/Button"
import { getEgeyurtIletisim } from "../../features/admin/adminSlice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 800px;
        height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        .content{
            margin-block: 20px;
            padding: 0 20px;
            display: flex;
            align-items: center;
            flex-direction: column;
            height: 100%;
            width: 100%;
            justify-content: center;
            .titles {
                width: 100%;
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                gap: 10px;
                padding-inline: 10px;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                text-align: center;
                color: ${({ theme }) => theme.mainTextColor};
                margin-bottom: 30px;
            }
            .info-container{
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 20px;
                .row{
                    width: 100%;
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr;
                    gap: 10px;
                    padding-inline: 10px;
                    color: ${({ theme }) => theme.mainTextColor};
                    text-align: center;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                    background-color: var(--color-light);
                    padding-block: 20px;
                    border-radius: 5px;
                }
            }
            
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 30px;
            margin-bottom: 20px;

        }
    }
`
const titles = ["Birim", "Telefon", "İşlemler"];

const IletisimBilgileriModal = () => {

    const dispatch = useDispatch()

    const location = useLocation()
    const { egeyurtIletisimList } = useSelector((state) => state.admin);
    const { theme } = useSelector((state) => state.layout);
    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

       //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    useEffect(() => {
        dispatch(getEgeyurtIletisim());
    }, []);
    
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
            <PageTopTitle title={"İletişim Bilgileri"}/>
            <div className="content">
                <div className="titles">
                    {titles.map((item) => (
                        <p>{item}</p>
                    ))}
                </div>
                <div className="info-container">
                    {
                        egeyurtIletisimList?.map((item) => (
                            <div className="row">
                                <p>{item?.tittle}</p>
                                <p>{item?.phoneNumber}</p>
                                <p>{item?.email}</p>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className='button-grp'>
                <Button color={"#F4F4F4"} background={"#E85446"} width="310px" radius={"10px"} text={"Geri Dön"} handleClick={()=> dispatch(showModal(null))}/>
            </div>
        </div>
    </ModalContainer>
  )
}

export default IletisimBilgileriModal